import * as B from '@blueprintjs/core';
import classNames from 'classnames';
import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import cs from 'app/components/CopyableText/styles.module.scss';

export type CopyableTextProps = {
  description: React.ReactNode;
  copyableText: string;
};

export const CopyableText: React.FC<CopyableTextProps> = ({description, copyableText}) => {
  const [isCopied, setCopied] = React.useState(false);

  React.useEffect(() => {
    if (!isCopied) return;

    const timeoutId = window.setTimeout(() => setCopied(false), 1500);
    return () => window.clearTimeout(timeoutId);
  }, [isCopied]);

  return (
    <>
      <div className={cs.shareDescriptionModal}>{description}</div>
      <CopyToClipboard text={copyableText} onCopy={() => setCopied(true)}>
        <div>
          <B.InputGroup
            className={classNames(cs.truncateUrl, cs.monospace)}
            type="text"
            value={copyableText}
            readOnly
            rightElement={
              <B.Button className={cs.fixedWidthButon}>{isCopied ? 'Copied!' : 'Copy'}</B.Button>
            }
          />
        </div>
      </CopyToClipboard>
    </>
  );
};
